'use client';

import { Fragment } from 'react';
import Frappe from './Frappe';
import Link from 'next/link';

const ServicesHero = ({ data }) => {
    const { title, subtitle, buttonText } = data.maintext;

    const renderLines = (text) =>
        text.split('\n').map((line, index) => (
            <Fragment key={index}>
                {line}
                <br />
            </Fragment>
        ));

    return (
        <div
            id="maintext2"
            className="pt-8 w-full flex flex-col items-center md:pt-32 md:pb-12"
        >
            <h1 className="hello_text text-3xl md:text-4xl font-bold text-gray-800 text-center">
                {renderLines(title)}
            </h1>

            <p className="my-4 md:my-5 text-gray-600 text-lg md:text-xl font-semibold text-center max-w-xl">
                {renderLines(subtitle)}
            </p>

            <Link rel="canonical" href="/contact-sales">
                <button className="hello_button py-3 px-10 md:py-2 md:px-8 bg-blue-500 rounded-md mt-4 shadow-xl hover:shadow-none transition duration-300">
                    <span className="font-bold text-white text-base md:text-lg">
                        {buttonText} <i className="ri-arrow-right-line"></i>
                    </span>
                </button>
            </Link>

            <div className="mt-6 md:mt-8">
                <Frappe />
                <p>
                    <i className="ri-star-fill text-yellow-300 text-2xl"></i>
                    <i className="ri-star-fill text-yellow-300 text-2xl"></i>
                    <i className="ri-star-fill text-yellow-300 text-2xl"></i>
                    <i className="ri-star-fill text-yellow-300 text-2xl"></i>
                    <span className="text-sm text-gray-600 ml-1">
                        Based on Customer Reviews
                    </span>
                </p>
            </div>
        </div>
    );
};

export default ServicesHero;
